import React from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  ENDPOINT_PATH,
  NEW_ENDPOINT_PATH,
  NEW_PAYMENT_METHOD_FOR_SECURITY_PROFILE_PATH,
  NEW_PROFILE_AUTHORIZED_BY_PROFILE_PATH,
  NEW_SECURITY_PROFILE_PATH,
  NEW_VIEW_PATH,
  PAYMENT_METHOD_FOR_SECURITY_PROFILE_PATH,
  PROFILE_AUTHORIZED_BY_PROFILE_PATH,
  SECURITY_PROFILE_PATH,
  SECURITY_UNIT_PATH,
  VIEW_PATH,
} from '../../../config/paths';
import SecurityHome from './SecurityHome';
import AuthorizedProfilesByProfile from './security/AuthorizedProfilesByProfile';
import NewAuthorizedProfileByProfile from './security/NewAuthorizedProfileByProfile';
import AuthorizedProfileByProfile from './security/AuthorizedProfileByProfile';
import EditAuthorizedProfileByProfile from './security/EditAuthorizedProfileByProfile';
import PaymentMethodsForSecurityProfiles from './payment-method-security-profile/PaymentMethodsForSecurityProfiles';
import PaymentMethodForSecurityProfile from './payment-method-security-profile/PaymentMethodForSecurityProfile';
import NewPaymentMethodForSecurityProfile from './payment-method-security-profile/NewPaymentMethodForSecurityProfile';
import EditPaymentMethodForSecurityProfile from './payment-method-security-profile/EditPaymentMethodForSecurityProfile';
import SecurityProfiles from './security-profile/SecurityProfiles';
import SecurityProfile from './security-profile/SecurityProfile';
import NewSecurityProfile from './security-profile/NewSecurityProfile';
import EditSecurityProfile from './security-profile/EditSecurityProfile';
import Views from './view/Views';
import View from './view/View';
import NewView from './view/NewView';
import EditView from './view/EditView';
import Endpoints from './endpoint/Endpoints';
import NewEndpoint from './endpoint/NewEndpoint';
import Endpoint from './endpoint/Endpoint';
import EditEndpoint from './endpoint/EditEndpoint';

const SecurityUnit = () => (
  <Switch>
    <Route exact path={SECURITY_UNIT_PATH} component={SecurityHome} />

    <Route
      exact
      path={SECURITY_PROFILE_PATH}
      component={SecurityProfiles}
    />

    <Route
      exact
      path={NEW_SECURITY_PROFILE_PATH}
      component={NewSecurityProfile}
    />

    <Route
      exact
      path={`${SECURITY_PROFILE_PATH}/:id`}
      component={SecurityProfile}
    />

    <Route
      exact
      path={`${SECURITY_PROFILE_PATH}/:id/edit`}
      component={EditSecurityProfile}
    />

    <Route
      exact
      path={VIEW_PATH}
      component={Views}
    />

    <Route
      exact
      path={NEW_VIEW_PATH}
      component={NewView}
    />

    <Route
      exact
      path={`${VIEW_PATH}/:id`}
      component={View}
    />

    <Route
      exact
      path={`${VIEW_PATH}/:id/edit`}
      component={EditView}
    />

    <Route
      exact
      path={PROFILE_AUTHORIZED_BY_PROFILE_PATH}
      component={AuthorizedProfilesByProfile}
    />
    <Route
      exact
      path={NEW_PROFILE_AUTHORIZED_BY_PROFILE_PATH}
      component={NewAuthorizedProfileByProfile}
    />
    <Route
      exact
      path={`${PROFILE_AUTHORIZED_BY_PROFILE_PATH}/:id`}
      component={AuthorizedProfileByProfile}
    />
    <Route
      exact
      path={`${PROFILE_AUTHORIZED_BY_PROFILE_PATH}/:id/edit`}
      component={EditAuthorizedProfileByProfile}
    />
    <Route
      exact
      path={NEW_PAYMENT_METHOD_FOR_SECURITY_PROFILE_PATH}
      component={NewPaymentMethodForSecurityProfile}
    />
    <Route
      exact
      path={PAYMENT_METHOD_FOR_SECURITY_PROFILE_PATH}
      component={PaymentMethodsForSecurityProfiles}
    />
    <Route
      exact
      path={`${PAYMENT_METHOD_FOR_SECURITY_PROFILE_PATH}/:id`}
      component={PaymentMethodForSecurityProfile}
    />
    <Route
      exact
      path={`${PAYMENT_METHOD_FOR_SECURITY_PROFILE_PATH}/:id/edit`}
      component={EditPaymentMethodForSecurityProfile}
    />
    <Route
      exact
      path={ENDPOINT_PATH}
      component={Endpoints}
    />
    <Route
      exact
      path={NEW_ENDPOINT_PATH}
      component={NewEndpoint}
    />
    <Route
      exact
      path={`${ENDPOINT_PATH}/:id`}
      component={Endpoint}
    />
    <Route
      exact
      path={`${ENDPOINT_PATH}/:id/edit`}
      component={EditEndpoint}
    />
  </Switch>
);

export default SecurityUnit;
